import { render, staticRenderFns } from "./cardImport.vue?vue&type=template&id=17033902&scoped=true&"
import script from "./cardImport.vue?vue&type=script&lang=js&"
export * from "./cardImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17033902",
  null
  
)

export default component.exports